var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('TrialV2',{attrs:{"sceneCode":"6","title":"申请体验"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }